"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactJss = require("react-jss");

var _default = (0, _reactJss.withStyles)(function (_ref) {
  var _root, _description;

  var screens = _ref.screens,
      colors = _ref.colors,
      spacing = _ref.spacing;
  return {
    root: (_root = {
      width: '100%',
      textAlign: 'center',
      borderTop: '1px solid #eae9e9'
    }, _defineProperty(_root, screens.mdUp, {
      padding: "".concat(spacing.xxl, "px 0 ").concat(spacing.lg, "px"),
      borderBottom: '1px solid #EDEDED',
      marginBottom: spacing.lg,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }), _defineProperty(_root, screens.smDown, {
      padding: "".concat(spacing.md, "px 0 ").concat(spacing.sm, "px")
    }), _root),
    link: {
      width: 87,
      display: 'inline-block'
    },
    logo: {
      display: 'inline-block',
      height: 0,
      paddingBottom: '54%',
      background: "url(/assets/images/aenetworks/aetn-charcoal-stacked.svg) no-repeat center center",
      backgroundSize: 'contain',
      color: 'transparent'
    },
    description: (_description = {
      color: colors.secondaryDarkContrast
    }, _defineProperty(_description, screens.mdUp, {
      textTransform: 'uppercase',
      marginTop: spacing.md
    }), _defineProperty(_description, screens.smDown, {
      display: 'none'
    }), _description)
  };
});

exports["default"] = _default;